import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import helpImage from './media/help.svg';

import styles from './Help.module.scss';

const Help: FC<IProps> = (props) => {
    return (
        <div className={classNames(styles.help, props.className)}>
            <img
                className={styles.image}
                src={helpImage}
                alt={'Help'}
            />
            {props.text}
        </div>
    );
};

export default Help;
